import i18n from 'i18n-js';
import * as types from './types';
import * as userActions from 'services/api/user';
import * as usersActions from 'services/api/users';
import { getErrorMessage, parsePagination, isCancel } from 'utils';
import { uiActions } from 'state/modules/UI';
import { AuthActions } from 'state/modules/auth';

// Get Users
const fetchUsersRequest = (payload) => ({
  type: types.FETCH_USERS_REQUEST,
  payload,
});

const fetchUsersSuccess = (payload) => ({
  type: types.FETCH_USERS_SUCCESS,
  payload,
});

const fetchUsersFailed = (payload) => ({
  type: types.FETCH_USERS_FAILED,
  payload,
});

export const fetchUsers = (params = {}, type = 'users', options) => {
  return async (dispatch) => {
    dispatch(fetchUsersRequest(type));
    const response = await usersActions.fetchUsers(params, options);
    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchUsersSuccess({
          pagination: pagination,
          data: response.data,
          type: type,
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );
      dispatch(fetchUsersFailed(type));
    }
  };
};

// Get Users Status
const fetchUsersStatusRequest = () => ({
  type: types.FETCH_USERS_STATUS_REQUEST,
});

const fetchUsersStatusSuccess = (payload) => ({
  type: types.FETCH_USERS_STATUS_SUCCESS,
  payload,
});

const fetchUsersStatusFailed = () => ({
  type: types.FETCH_USERS_STATUS_FAILED,
});

export const fetchUsersStatus = () => {
  return async (dispatch) => {
    dispatch(fetchUsersStatusRequest());

    const response = await usersActions.fetchUsersStatus();

    if (response.ok) {
      return dispatch(fetchUsersStatusSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUsersStatusFailed(error));
  };
};

// Get User by id
const fetchUserByIdRequest = () => ({
  type: types.FETCH_USER_BY_ID_REQUEST,
});

const fetchUserByIdSuccess = (payload) => ({
  type: types.FETCH_USER_BY_ID_SUCCESS,
  payload,
});

const fetchUserByIdFailed = () => ({
  type: types.FETCH_USER_BY_ID_FAILED,
});

const fetchResetUser = () => ({
  type: types.RESET_USER,
});

export const fetchUserById = (id, type, list = false) => {
  return async (dispatch) => {
    dispatch(fetchUserByIdRequest());
    const response = await usersActions.fetchUserById(id);
    if (response.ok) {
      if (list) {
        return dispatch(
          fetchUsersSuccess({
            pagination: {},
            data: [response.data],
            type: type,
          })
        );
      }
      return dispatch(fetchUserByIdSuccess(response.data));
    }
    const error = getErrorMessage(response.data);
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    dispatch(fetchUserByIdFailed(error));
  };
};

export const resetUser = () => {
  return async (dispatch) => {
    dispatch(fetchResetUser());
  };
};

// Get user groups
const fetchUserGroupsRequest = () => ({
  type: types.FETCH_USER_GROUPS_REQUEST,
});

const fetchUserGroupsSuccess = (payload) => ({
  type: types.FETCH_USER_GROUPS_SUCCESS,
  payload,
});

const fetchUserGroupsFailed = () => ({
  type: types.FETCH_USER_GROUPS_FAILED,
});

export const fetchUserGroups = (userId, params = {}) => {
  return async (dispatch) => {
    dispatch(fetchUserGroupsRequest());

    const response = await usersActions.fetchUserGroups(userId, params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchUserGroupsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUserGroupsFailed(error));
  };
};

// Add service groups
const fetchAddUserVehicleGroupsRequest = () => ({
  type: types.FETCH_ADD_USER_VEHICLE_GROUPS_REQUEST,
});

const fetchAddUserVehicleGroupsSuccess = (payload) => ({
  type: types.FETCH_ADD_USER_VEHICLE_GROUPS_SUCCESS,
  payload,
});

const fetchAddUserVehicleGroupsFailed = () => ({
  type: types.FETCH_ADD_USER_VEHICLE_GROUPS_FAILED,
});

export const fetchAddUserVehicleGroups = (userId, payload) => {
  return async (dispatch) => {
    dispatch(fetchAddUserVehicleGroupsRequest());

    const response = await usersActions.fetchAddUserVehicleGroups(userId, payload);

    if (response.ok) {
      return dispatch(
        fetchAddUserVehicleGroupsSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchAddUserVehicleGroupsFailed(error));
  };
};

// Remove service groups
const fetchDeleteUserVehicleGroupsRequest = () => ({
  type: types.FETCH_DELETE_USER_VEHICLE_GROUPS_REQUEST,
});

const fetchDeleteUserVehicleGroupsSuccess = (payload) => ({
  type: types.FETCH_DELETE_USER_VEHICLE_GROUPS_SUCCESS,
  payload,
});

const fetchDeleteserVehicleGroupsFailed = () => ({
  type: types.FETCH_DELETE_USER_VEHICLE_GROUPS_FAILED,
});

export const fetchDeleteUserVehicleGroups = (userId, goupId) => {
  return async (dispatch) => {
    dispatch(fetchDeleteUserVehicleGroupsRequest());

    const response = await usersActions.fetchDeleteUserVehicleGroups(userId, goupId);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.vg_success_message'),
        })
      );
      return dispatch(
        fetchDeleteUserVehicleGroupsSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchDeleteserVehicleGroupsFailed(error));
  };
};

// Add user groups
const fetchAddUserGroupsRequest = () => ({
  type: types.FETCH_ADD_USER_GROUPS_REQUEST,
});

const fetchAddUserGroupsSuccess = (payload) => ({
  type: types.FETCH_ADD_USER_GROUPS_SUCCESS,
  payload,
});

const fetchAddUserGroupsFailed = () => ({
  type: types.FETCH_ADD_USER_GROUPS_FAILED,
});

export const fetchAddUserGroups = (userId, goupId) => {
  return async (dispatch) => {
    dispatch(fetchAddUserGroupsRequest());

    const response = await usersActions.fetchAddUserGroups(userId, goupId);

    if (response.ok) {
      return dispatch(
        fetchAddUserGroupsSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchAddUserGroupsFailed(error));
  };
};

// Remove user groups
const fetchDeleteUserGroupsRequest = () => ({
  type: types.FETCH_DELETE_USER_GROUPS_REQUEST,
});

const fetchDeleteUserGroupsSuccess = (payload) => ({
  type: types.FETCH_DELETE_USER_GROUPS_SUCCESS,
  payload,
});

const fetchDeleteUserGroupsFailed = () => ({
  type: types.FETCH_DELETE_USER_GROUPS_FAILED,
});

export const fetchDeleteUserGroups = (userId, groupId) => {
  return async (dispatch) => {
    dispatch(fetchDeleteUserGroupsRequest());

    const response = await usersActions.fetchDeleteUserGroups(userId, groupId);

    if (response.ok) {
      return dispatch(
        fetchDeleteUserGroupsSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchDeleteUserGroupsFailed(error));
  };
};

// Send link confirmation
const fetchUserInfoActionRequest = () => ({
  type: types.FETCH_USER_INFO_ACTION_REQUEST,
});

const fetchUserInfoActionSuccess = () => ({
  type: types.FETCH_USER_INFO_ACTION_SUCCESS,
});

const fetchUserInfoActionFailed = () => ({
  type: types.FETCH_USER_INFO_ACTION_FAILED,
});

export const fetchSendConfirmationLink = (id, email) => {
  const payload = {
    user_id: id,
    new_email: email,
  };

  return async (dispatch) => {
    dispatch(fetchUserInfoActionRequest());

    const response = await usersActions.fetchEmailConfirm(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.email_confirmation_success_message'),
        })
      );
      return dispatch(fetchUserInfoActionSuccess());
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUserInfoActionFailed(error));
  };
};

// Send link confirmation
export const fetchSendPasswordReset = (email, bastion) => {
  const payload = {
    email,
    bastion_slug: bastion,
  };

  return async (dispatch) => {
    dispatch(fetchUserInfoActionRequest());

    const response = await usersActions.fetchSendPasswordReset(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.password_reset_sussess_message'),
        })
      );
      return dispatch(fetchUserInfoActionSuccess());
    }

    const error = getErrorMessage(response.data);
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUserInfoActionFailed());
  };
};

// Send phone confirmation sms
export const fetchSendPhoneConfirmationSMS = (id, phone) => {
  const payload = {
    user_id: id,
    mobile_phone: phone?.replace(new RegExp('-', 'g'), ''),
  };

  return async (dispatch) => {
    dispatch(fetchUserInfoActionRequest());

    const response = await usersActions.fetchPhoneConfirm(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.phone_confirmation_success_message'),
        })
      );
      return dispatch(fetchUserInfoActionSuccess());
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUserInfoActionFailed());
  };
};

// Update user status
const fetchUpdateUserStatusRequest = () => ({
  type: types.FETCH_UPDATE_USER_STATUS_REQUEST,
});

const fetchUpdateUserStatusSuccess = (payload) => ({
  type: types.FETCH_UPDATE_USER_STATUS_SUCCESS,
  payload,
});

const fetchUpdateUserStatusFailed = () => ({
  type: types.FETCH_UPDATE_USER_STATUS_FAILED,
});

export const fetchUpdateUserStatus = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateUserStatusRequest());

    const response = await usersActions.fetchUpdateUserStatus(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.status_updated_successfully'),
        })
      );
      return dispatch(fetchUpdateUserStatusSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUpdateUserStatusFailed(error));
  };
};

// Update user role
const fetchUpdateUserRoleRequest = () => ({
  type: types.FETCH_UPDATE_USER_ROLE_REQUEST,
});

const fetchUpdateUserRoleSuccess = (payload) => ({
  type: types.FETCH_UPDATE_USER_ROLE_SUCCESS,
  payload,
});

const fetchUpdateUserRoleFailed = () => ({
  type: types.FETCH_UPDATE_USER_ROLE_FAILED,
});

export const fetchUpdateUserRole = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateUserRoleRequest());

    const response = await usersActions.fetchUpdateUserRole(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.role_updated_successfully'),
        })
      );
      return dispatch(fetchUpdateUserRoleSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUpdateUserRoleFailed(error));
  };
};

export const resetChangeUserStatus = () => (dispatch) => {
  return dispatch({
    type: types.FETCH_RESET_UPDATE_USER_STATUS,
  });
};

// Update user
const fetchUpdateUserRequest = () => ({
  type: types.FETCH_UPDATE_USER_REQUEST,
});

const fetchUpdateUserSuccess = (payload) => ({
  type: types.FETCH_UPDATE_USER_SUCCESS,
  payload,
});

const fetchUpdateUserFailed = (errors) => ({
  type: types.FETCH_UPDATE_USER_FAILED,
  errors,
});

export const fetchUpdateUser = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateUserRequest());

    const response = await usersActions.fetchUpdateUser(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.user_updated_successfully'),
        })
      );
      dispatch(AuthActions.fetchUserUpdated());
      return dispatch(fetchUpdateUserSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
      return dispatch(fetchUpdateUserFailed());
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(fetchUpdateUserFailed(errors));
  };
};

// Create user
const fetchCreateUserRequest = () => ({
  type: types.FETCH_CREATE_USER_REQUEST,
});

const fetchCreateUserSuccess = (payload) => ({
  type: types.FETCH_CREATE_USER_SUCCESS,
  payload,
});

const fetchCreateUserFailed = (errors) => ({
  type: types.FETCH_CREATE_USER_FAILED,
  errors,
});

export const fetchCreateUser = (data) => {
  return async (dispatch) => {
    dispatch(fetchCreateUserRequest());

    const response = await userActions.createUser(data);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('users.customer_created_successfully'),
        })
      );
      return dispatch(fetchCreateUserSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
      return dispatch(fetchCreateUserFailed());
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(fetchCreateUserFailed(errors));
  };
};

export const resetChangeUserRole = () => (dispatch) => {
  return dispatch({
    type: types.FETCH_RESET_UPDATE_USER_ROLE,
  });
};

/*
 *RESET UPDATE USER
 */
export const resetUpdateUser = () => (dispatch) => {
  dispatch({
    type: types.RESET_UPDATE_USER_SUCCESS,
  });
};

// DELETE USER
const fetchDeleteUserRequest = () => ({
  type: types.FETCH_DELETE_USER_REQUEST,
});

const fetchDeleteUserSuccess = (payload) => ({
  type: types.FETCH_DELETE_USER_SUCCESS,
  payload,
});

const fetchDeleteUserFailed = (payload) => ({
  type: types.FETCH_DELETE_USER_FAILED,
  payload,
});

export const fetchDeleteUser = (id, type = 'user', payload) => {
  return async (dispatch) => {
    dispatch(fetchDeleteUserRequest());
    const response = await usersActions.fetchDeleteUser(id, payload);
    if (response.ok || response.status === 200 || response.status === 204) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message:
            type === 'customer'
              ? i18n.t('customers.delete_success')
              : i18n.t('users.delete_success'),
        })
      );
      return dispatch(fetchDeleteUserSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
      return dispatch(fetchDeleteUserFailed());
    }

    let errors = {};
    let message = '';
    let showConfirm = false;

    formattedError?.length &&
      formattedError.map((val) => (errors[val.field || val.key] = val.message));

    if (errors['CANNOTMODIFY']) {
      showConfirm = true;
      message = errors['CANNOTMODIFY'];
    } else {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError[0].message,
        })
      );
    }

    dispatch(fetchDeleteUserFailed({ errors, showConfirm, message }));
  };
};

/*
 *RESET DELETE USER
 */
export const resetDeleteUser = () => (dispatch) => {
  dispatch({
    type: types.RESET_DELETE_USER_SUCCESS,
  });
};

const fetchUserPrivilegesRequest = () => ({
  type: types.FETCH_USERS_PRIVILEGES_REQUEST,
});

const fetchUserPrivilegesSuccess = (payload) => ({
  type: types.FETCH_USERS_PRIVILEGES_SUCCESS,
  payload,
});

const fetchUserPrivilegesFailure = (error) => ({
  type: types.FETCH_USERS_PRIVILEGES_FAILURE,
  error,
});

export const fetchUserPrivileges = (userId) => async (dispatch) => {
  dispatch(fetchUserPrivilegesRequest());

  const response = await usersActions.fetchUserPrivileges(userId);

  if (response.ok) {
    return dispatch(fetchUserPrivilegesSuccess(response.data));
  }

  const error = getErrorMessage(response.data);

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: error,
    })
  );

  dispatch(fetchUserPrivilegesFailure(error));
};
/*
 * RESET ASSIGN VEHICLE GROUPS
 */
export const resetAddVehicleGroups = () => (dispatch) => {
  dispatch({
    type: types.RESET_ADD_USER_VEHICLE_GROUPS_SUCCESS,
  });
};

// Update qualifications
const fetchUpdateUserQualificationsRequest = () => ({
  type: types.FETCH_UPDATE_USER_QUALIFICATIONS_REQUEST,
});

const fetchUpdateUserQualificationsSuccess = (payload) => ({
  type: types.FETCH_UPDATE_USER_QUALIFICATIONS_SUCCESS,
  payload,
});

const fetchUpdateUserQualificationsFailed = (errors) => ({
  type: types.FETCH_UPDATE_USER_QUALIFICATIONS_FAILED,
  errors,
});

export const fetchUpdateUserQualifications = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateUserQualificationsRequest());

    const response = await usersActions.fetchUpdateUserQualifications(id, payload);

    if (response.ok) {
      return dispatch(fetchUpdateUserQualificationsSuccess(response.data));
    }

    const error = getErrorMessage(response.data, { fullObject: true });

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    return dispatch(fetchUpdateUserQualificationsFailed());
  };
};

const fetchAccountBrokersRequest = (payload) => ({
  type: types.FETCH_ACCOUNT_BROKERS_REQUEST,
  payload,
});

const fetchAccountBrokersSuccess = (payload) => ({
  type: types.FETCH_ACCOUNT_BROKERS_SUCCESS,
  payload,
});

const fetchAccountBrokersFailed = (payload) => ({
  type: types.FETCH_ACCOUNT_BROKERS_FAILED,
  payload,
});

export const fetchAccountBrokers = (id) => async (dispatch) => {
  dispatch(fetchAccountBrokersRequest());

  const response = await usersActions.getAccountBrokers(id);

  if (response.ok) {
    return dispatch(fetchAccountBrokersSuccess(response.data));
  }

  const formattedError = getErrorMessage(response.data);

  dispatch(fetchAccountBrokersFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

// USER DELETION
const fetchDeletionUserRequest = () => ({
  type: types.FETCH_DELETION_USER_REQUEST,
});

const fetchDeletionUserSuccess = (payload) => ({
  type: types.FETCH_DELETION_USER_SUCCESS,
  payload,
});

const fetchDeletionUserFailed = () => ({
  type: types.FETCH_DELETION_USER_FAILED,
});

/*
 *RESET DELETION USER
 */
 export const resetDeletionUser = () => (dispatch) => {
  dispatch({
    type: types.RESET_DELETION_USER_SUCCESS,
  });
};

export const fetchDeletionUser = (id, body) => {
  return async (dispatch) => {
    dispatch(fetchDeletionUserRequest());
    const response = await usersActions.fetchDeletionUser(id, body);
    if (response.ok || response.status === 200 || response.status === 204) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t(`customers.deletion_${body.deletion_status}`),
        })
      );
      return dispatch(fetchDeletionUserSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data);
    if (typeof formattedError === 'string') {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    } else {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError[0].message,
        })
      );
    }

    dispatch(fetchDeletionUserFailed());
  };
};